<template>
  <div>
    <el-dialog
            :visible.sync="showModel"
            :modal="isModal"
            :show-close="false"
            :close-on-click-modal="false"
            :close-on-press-escape="false"
            :modalAppendToBody="false"
            :append-to-body="appendToBody"
            width="80%"
            custom-class="pointsExchangeDialog">
        <div class="container" v-if="showSecondPassWord === false ">
            <img src="../../../assets/images/dialog_ticket.svg" class="icon">
            <el-row type="flex" justify="space-between" class="w-100">
<!--                <el-col :span="8" class="text-right">-->
<!--                    <el-button icon="el-icon-minus" circle @click="decreaseValue()"></el-button>-->
<!--                </el-col>-->
<!--                <el-col :span="8" class="text-center" style="font-size: 20px;">{{costCount}}</el-col>-->
<!--                <el-col :span="8" class="text-left">-->
<!--                    <el-button icon="el-icon-plus" circle @click="increaseValue()"></el-button>-->
<!--                </el-col>-->
                <number-controller :params="numberControllerParams" @triggerEvent="numberControllerEvent" :reset="index"/>
            </el-row>
            <el-row type="flex" justify="space-between" class="w-100 mt-4">
                <el-col :span="8" class="text-right">
                    本次扣除
                </el-col>
                <el-col :span="8" class="text-center red">
                    {{deductPoint}}
                </el-col>
                <el-col :span="8">
                    <span class="ml-2">點</span>
                </el-col>
            </el-row>
            <el-row type="flex" justify="space-between" class="w-100">
                <el-col :span="8" class="text-right">
                    目前剩餘
                </el-col>
                <el-col :span="8" class="text-center">
                    {{pointAmount}}
                </el-col>
                <el-col :span="8">
                    <span class="ml-2">點</span>
                </el-col>
            </el-row>
            <el-row type="flex" justify="space-between" class="w-100" v-if="exchangeMethod === 2">
              <el-col :span="8" class="text-right">
                加價金額
              </el-col>
              <el-col :span="8" class="text-center">
                {{deductPrice}}
              </el-col>
              <el-col :span="8">
                <span class="ml-2">元</span>
              </el-col>
            </el-row>
            <el-row type="flex" justify="space-between" class="w-100">
              <el-col :span="8" class="text-right">
                兌換數量
              </el-col>
              <el-col :span="8" class="text-center">
                {{totalConvertCount}}
              </el-col>
              <el-col :span="8">
                <span class="ml-2">{{unit}}</span>
              </el-col>
            </el-row>
            <div slot="footer" class="dialog-footer">
                <el-button @click="cancel" round type="info">取消</el-button>
                <el-button @click="confirm" round type="primary">送出</el-button>
            </div>
        </div>
        <div class="container" v-if="showSecondPassWord === true">
            <img src="../../../assets/images/dialog-exchange.svg" class="mb-0">
            <p class="text-center">請出示本畫面給現場人員<br>輸入兌換密碼</p>
            <div class="second-password">
                <el-input
                        v-model="input"
                        show-password
                        minlength="4"
                        maxlength="4">
                </el-input>
                <div class="box">
                    <span v-if="input.length >= 1"/>
                </div>
                <div class="box">
                    <span v-if="input.length >= 2"/>
                </div>
                <div class="box">
                    <span v-if="input.length >= 3"/>
                </div>
                <div class="box">
                    <span v-if="input.length >= 4"/>
                </div>
            </div>

            <div slot="footer" class="dialog-footer">
                <el-button @click="cancel" round type="info">取消</el-button>
                <el-button @click="confirm" round type="primary">送出</el-button>
            </div>
        </div>
    </el-dialog>
    <comm-dialog :value="isShowDialog" outerContent="確定要兌換？"
                 :icon="icons"
                 :append-to-body="isWeb"
                 @result="dialogResult"
    />
    <comm-dialog :value="isShowMessageDialog" :outerContent="messageOuterContent" :isCancel="false" positiveLabel="關閉"
                 :icon="icons" :isShowTime="isShowTimes"
                 :append-to-body="isWeb"
                 @result="messageDialogResult"
    />
    <comm-dialog :value="isShowQrcodeDialog" :outerContent="qrcodeDialogOuterContent" :isCancel="false"  positiveLabel="關閉"
                 :isIcon="isIcon" :isQrcode="isQrcode" :qrcodeSrc="qrcodeSrc"
                 :append-to-body="isWeb"
                 @result="isShowQrcodeDialog = false"
    />
    <loading
        :active.sync=isLoading
        :can-cancel="false"
        :is-full-page="true">
    </loading>
  </div>
</template>

<script>
    import CommDialog from "@/components/CommDialog";
    import * as mutationTypes from "@/store/mutationTypes";
    import * as constDefine from "@/store/constDefine";
    import NumberController from "@/components/NumberController";

    export default {
        name: "PointsExchangeDialog",
        props: {
            value: {required: false, type: Boolean, default: false}, //是否顯示 dialog (dialog開關)?
            isModal: {default: true},
            convertData: {},
            appendToBody:{default: false},
            isWeb: {default: false},
        },
        components: {
            CommDialog,
            NumberController,
        },
        data() {
            return {
                isLoading: false,
                showModel: false,               //是否顯示 dialog

                pointAmount: 0,                 //目前剩餘點數
                id: 0,
                type: 0,                        //兌換種類
                typeId: 0,                      //對應的id
                convertMethod: 0,               //兌換方法
                deductPoint: 0,                 //本次要扣掉多少點數
                deductPrice: 0,                 //本次要扣除多少費用
                totalConvertCount: 0,           //本次總兌換數量
                costPoint: 0,                   //單次要扣除多少點數
                costPrice: 0,                   //單次要扣除多少費用
                convertCount: 0,                //單次兌換數量
                unit: "",                       //單位
                exchangeMethod: 0,              //1:免費兌換、2:加價兌換

                costCount: 1,                   //計算要兌換多少次數
                input: '',                      //二級密碼表單
                showSecondPassWord: false,

                isShowDialog: false,

                isShowMessageDialog: false,

                messageOuterContent: '',

                isShowQrcodeDialog: false,
                qrcodeDialogOuterContent: "",
                isIcon: false,
                isQrcode: true,
                qrcodeSrc: "",

                isTriggerResult: false,

                //數量增減元件
                numberControllerParams: {
                    default: 1,
                    min: 1,
                    max: 1,
                },

                index: 0,
                icons: require('@/assets/images/dialog_ticket.svg'),
                isShowTimes: false,
                isSuccess: false,
                checkUseTimer: null,
                checkUseTimerCount: 0,
            }
        },
        beforeDestroy() {
            clearInterval(this.checkUseTimer);
        },
        watch: {
            value: function () {
                if(this.value) {
                  this.costCount = 1;
                  this.pointAmount = this.convertData.pointAmount;
                  this.id = this.convertData.id;
                  this.type = this.convertData.type;
                  this.typeId = this.convertData.typeId;
                  this.convertMethod = this.convertData.convertMethod;
                  this.deductPoint = this.convertData.costPoint;
                  this.deductPrice = this.convertData.costPrice;
                  this.totalConvertCount = this.convertData.convertCount;
                  this.costPoint = this.convertData.costPoint;
                  this.costPrice = this.convertData.costPrice;
                  this.convertCount = this.convertData.convertCount;
                  this.unit = this.convertData.unit;
                  this.exchangeMethod = this.convertData.exchangeMethod;

                  //計算最大可兌換的上限
                  this.numberControllerParams.max = Math.trunc(this.pointAmount/this.deductPoint);

                  //強制令 NumberController重置
                  this.index = this.index+1;
                }
                this.showModel = this.value;
            },
            '$store.state.publicCommDialogData.isShowDialog': function () {
                let routerName = this.$route.name
                if (routerName === 'LoyaltyCardExchange' || routerName === 'LoyaltyCardExchangeDetail' || (routerName === 'WebStoreLoyaltyCard' && this.isWeb)) {
                    if (!this.$store.state.publicCommDialogData.isShowDialog &&
                        this.$store.state.publicCommDialogData.isResultEvent &&
                        this.$store.state.publicCommDialogData.eventName === constDefine.ACTION_LOYALTY_CARD_EXCHANGE) {
                        this.isShowQrcodeDialog = false;
                        this.$emit('result', true);
                        this.$store.commit(mutationTypes.setPublicCommDialogData, {
                            isResultEvent: false,
                            eventName: "",
                        });

                        if (this.isWeb) {
                            window.location.reload();
                        }
                    }
                }
            },
            isShowQrcodeDialog() {
                if (this.isWeb) {
                    clearInterval(this.checkUseTimer);
                    if (this.isShowQrcodeDialog) {
                        let time = this.$public.dateFormat('yyyy-MM-dd hh:mm:ss')
                        this.checkUseTimerCount = 0
                        this.checkUseTimer = setInterval(() => {
                            this.checkUseTimerCount++
                            if (this.checkUseTimerCount > 60) {
                                clearInterval(this.checkUseTimer);
                                this.$store.commit(mutationTypes.setPublicCommDialogData, {
                                    isShowDialog: true,
                                    outerContent: '逾時，請重新操作',
                                });
                            } else {
                                this.checkUseLoyaltyCard(time)
                            }
                        }, 3000)
                    }
                }
            },
        },
        methods: {
            cancel: function () {
                this.$emit('result', false);
            },
            confirm: function () {
                //掃碼或直接兌換初始送出-判斷數量不足時
                if(this.deductPoint > this.pointAmount) {
                    this.isShowTimes=false
                    this.icons = require('@/assets/images/dialog_question.svg')
                  this.messageOuterContent = "集點卡點數不足"
                  this.isShowMessageDialog = true;
                } else {
                  if(this.convertMethod === 1) {
                    this.isShowDialog = true;
                  } else {
                    this.sendExchangeRequest()
                  }
                }
            },
            increaseValue: function () {
                if (this.deductPoint + this.costPoint <= this.pointAmount) {
                    this.costCount = this.costCount + 1;
                    this.deductPoint = this.deductPoint + this.costPoint;
                    this.deductPrice = this.deductPrice + this.costPrice;
                    this.totalConvertCount = this.totalConvertCount + this.convertCount;
                }
            },
            decreaseValue: function () {
                if (this.costCount - 1 > 0) {
                    this.costCount = this.costCount - 1;
                    this.deductPoint = this.deductPoint - this.costPoint;
                    this.deductPrice = this.deductPrice - this.costPrice;
                    this.totalConvertCount = this.totalConvertCount - this.convertCount;
                }
            },
            changeValue: function (val) {
                if (val > 0 && ((this.costPoint * val) <= this.pointAmount) ) {
                    if (this.costCount !== val) {
                        this.deductPoint = this.costPoint * val;
                        this.deductPrice = this.costPrice * val;
                        this.totalConvertCount = this.convertCount * val;
                        this.costCount = val;
                    }
                }
            },
            dialogResult(result) {
              if(result){
                this.sendExchangeRequest()
              } else {
                this.isShowDialog = false
              }
            },
            messageDialogResult() {
                this.isShowMessageDialog = false
                if (this.isTriggerResult) {
                    this.$emit('result', true);
                    this.isTriggerResult = false
                }

                if (this.isWeb && this.isSuccess) {
                    window.location.reload();
                }
            },
            sendExchangeRequest: function () {
                this.isLoading = true;
                this.isSuccess = false;

                this.$http.fetchWithAuthEncrypt`UseLoyaltyCardExchange${{
                    'id': this.id,
                    'count': this.costCount,
                    'exchangeMethod': this.exchangeMethod,
                }}
                ${json => {
                    this.isShowDialog = false;

                    this.messageOuterContent = json.message;
                    if (json.status) {
                        //直接兌換成功
                        if (json.data.convertMethod === 1) {
                            this.isTriggerResult = true;
                            this.isShowMessageDialog = true;
                            this.isShowTimes = true
                            this.isSuccess = true
                            this.icons = require('@/assets/images/dialog_complete.gif')
                        } else if (json.data.convertMethod === 2) {
                            //使用QR碼兌換
                            this.qrcodeSrc = json.data.qrcodeToken;
                            this.qrcodeDialogOuterContent = json.data.productName + 'QR碼';
                            this.isShowQrcodeDialog = true;
                        }
                    } else {
                        //直接兌換失敗
                        this.isShowMessageDialog = true;
                        this.isShowTimes = false
                        this.icons = require('@/assets/images/dialog_question.svg')
                    }

                    this.isLoading = false;
                }}`;
            },

            /** 數量變動事件 */
            numberControllerEvent(obj) {
                let self = this;
                let event = obj.event;

                if (event === "returnNumber") {

                    if(obj.operate === "add") {
                        self.increaseValue();

                    } else if(obj.operate === "dec") {
                        // alert("點數不可少於 1 點");
                        self.decreaseValue();
                    } else if(obj.operate === "change") {
                        self.changeValue(obj.number);
                    }

                } else if (event === "clickDisabledButton") {
                    //已經額滿的狀態下又按異動
                    if(obj.operate === "dec") {
                        // this.showDialog('點數不可少於 1 點');
                        alert("點數不可少於 1 點");
                    }
                }
            },
            checkUseLoyaltyCard(time) {
                let self = this;
                self.$http.fetchWithAuthEncrypt`CheckUseLoyaltyCard${{
                    id: self.id,
                    time: time,
                    count: self.costCount,
                }}${json => {
                    if (json.status) {
                        clearInterval(this.checkUseTimer);
                        self.$store.commit(mutationTypes.setPublicCommDialogData, {
                            isShowDialog: true,
                            outerContent: '兌換成功',
                            icons: require('@/assets/images/dialog_complete.gif'),
                            isResultEvent: true,
                            eventName: constDefine.ACTION_LOYALTY_CARD_EXCHANGE,
                        });
                    }
                }}}`;
            },
        }
    }
</script>